<template>
  <div class="BackBtnComp">
    <MultiBtn
      v-if="labels && routeTo"
      id="back-button"
      :route-to="routeTo"
      :text="labels.btn_text"
      :label="labels.btn_title"
      :theme="theme"
      direction="left"
      icon="arrow-left"
      is-nav
    />
  </div>
</template>

<script>
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BackBtn',

  components: {
    MultiBtn
  },

  computed: {
    // Data
    ...mapGetters([
      'getAoiBySlug',
      'routeName',
      'routeAoi',
      'myStore',
    ]),
    // Labels
    labels() { return this.myStore(['labels', 'header', 'back_button']) ?? {} },
    // Styles
    styles() { return this.myStore(['styles', 'header', 'back_button']) ?? {} },
    theme() { return this.styles.button_style ?? 'button_style_4' },
    // Route matches
    isTopLevelNav() { return ['area-of-interest', 'guided-tour', 'je-panorama'].includes(this.routeName) },
    MainMenuEnabled() { return this.myStore(['settings', 'main_menu_enabled']) ?? false },
    isSublevel() { return ['aoi-sublevel'].includes(this.routeName) },
    isAoiMedia() { return ['aoi-panorama', 'aoi-media'].includes(this.routeName) },
    isGtPanorama() { return ['gt-panorama'].includes(this.routeName) },
    // Route
    newRouteName() {
      const { getAoiBySlug, routeName, routeAoi, isTopLevelNav, MainMenuEnabled, isSublevel, isAoiMedia, isGtPanorama } = this
      // Top-level Nav
      if (isTopLevelNav && MainMenuEnabled) { return 'main-menu' }
      // Aoi - Sublevel
      if (isSublevel) {
        const { parent } = routeAoi
        return parent ? 'aoi-sublevel' : 'area-of-interest'
      }
      // Aoi - Media
      if (isAoiMedia) { return 'aoi-sublevel' }
      // GT - Media
      if (isGtPanorama) { return 'guided-tour' }
      // Fallback
      return 'home'
    },
    routeTo() {
      const { routeAoi, newRouteName, isAoiMedia } = this
      const isJustExplore = ['je-panorama'].includes(newRouteName)
      const justExploreBack = this.myStore(['justExploreBack']) ?? {}
      if (isJustExplore && justExploreBack.name) { return justExploreBack }
      const requiresAoiId = ['aoi-sublevel'].includes(newRouteName)
      const params = {}
      if (requiresAoiId) {
        const currentAoi = routeAoi || {}
        const { slug, parent } = currentAoi
        const currentAoiSlug = slug || ''
        const parentSlug = parent && parent.slug
        const aoiSlug = isAoiMedia ? currentAoiSlug : parentSlug
        params.aoi_id = aoiSlug
      }
      return {
        name: this.newRouteName,
        params
      }
    }
  },
}
</script>
